import type { SxProps, Theme } from '@mui/material';

export const header: SxProps<Theme> = {
  py: 5,
  px: 3,
};

export const headerContent: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
};

export const themeToggleContainer: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  gap: 1,
};
